import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { GoogleConfigService } from 'src/app/private/services/googleConfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-google-config',
  imports: [SharedModule],
  templateUrl: './delete-google-config.component.html',
  styleUrl: './delete-google-config.component.scss'
})
export class DeleteGoogleConfigComponent {
 @Input() googleConfigDataToEdit: any = null;
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private emailConfigService: GoogleConfigService,
    private messageService: MessageService
  ) { }


  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      id: this.googleConfigDataToEdit.id,
      client_id: this.clientId // Ensure client_id is set from input
    };
    this.emailConfigService.deleteGoogleConfig(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Department deleted successfully'
          });
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the department'
          });
        }
      }
    );
  }
}
